import CompanyRepository from './company.repository'

export default CompanyRepository
